import React from 'react';

export function KiddiFitWordmark({ withTM = true, className = '' }) {
  return (
    <span className={`kiddifit-brand ${className}`.trim()}>
      <span className='letter'>K</span>
      <span className='letter'>i</span>
      <span className='letter'>d</span>
      <span className='letter'>d</span>
      <span className='letter'>i</span>
      <span className='letter'>F</span>
      <span className='letter'>i</span>
      <span className='letter'>t</span>
      {withTM && <sup className='tm-symbol-inline'>TM</sup>}
    </span>
  );
}

export function KiddiFitInline({ withTM = true, className = '' }) {
  return (
    <>
      <KiddiFitWordmark withTM={withTM} className={className} />
    </>
  );
}
